import formButton from '@/components/common/form-button/form-button.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    formButton
  },
  methods: {
    ...mapActions('app', ['redirectTo']),
    ...mapActions('template', ['setCurrentTemplate']),
    useTemplate: function () {
      this.setCurrentTemplate({ id: this.id })
      this.redirectTo('create-competition')
    }
  },
  props: {
    name: {
      type: String
    },
    description: {
      type: String
    },
    mechanic_name: {
      type: String
    },
    mechanic: {
      type: String
    },
    image: {
      type: String
    },
    id: {
      type: Number
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/cards/card-template/card-template.js